<div class="smart-banner" *ngIf="!bannerClosed && bannerVisible">
  <div class="close-banner" (click)="closeBanner()">X</div>
  <div class="banner-logo">
    <img src="/assets/images/identibase/identibase-android-logo.png" alt="App Logo">
  </div>
  <div class="banner-info">
    <div class="app-name">identi</div>
    <div class="app-rating">Lifestyle</div>
  </div>
  <div class="banner-action">
    <button class="action-btn" (click)="openMobileApp()">Open our app</button>
  </div>
</div>
